<template>
  <div>
    <div class="mb-4">
      <h4 class="mt-0 mb-0 font-weight-bold text-dark">MUIC Pass</h4>
    </div>
    <b-row class="mb-3">
      <b-col cols="12" sm="12" md="7" order-md="5">
        <b-card>
          <template #header>
            <h4 class="mt-0 mb-2 font-weight-bold">Your ATK results</h4>
            <p class="mb-2 f-16">
              Each test result is valid for 7 days. (ผลตรวจสามารถใช้เข้าอาคารได้
              7 วัน)
            </p>
          </template>
          <div v-if="dataATKTest.length != 0">
            <h3 class="mt-0 mb-1">
              ATK status:
              <b-badge
                :variant="
                  diffExpirseDate(dataATKTest[0].check_date)
                    ? 'success'
                    : 'warning'
                "
              >
                <span
                  class="font-weight-bold"
                  v-if="diffExpirseDate(dataATKTest[0].check_date)"
                  >Active</span
                >
                <span class="font-weight-bold" v-else>Expired</span>
              </b-badge>
            </h3>
            <h5 class="mt-0 mb-0">
              Valid Until :
              <b-badge variant="secondary">
                {{
                  moment(moment(dataATKTest[0].check_date).format("YYYY-MM-DD"))
                    .add(7, "days")
                    .format("DD / MM / YYYY")
                }}</b-badge
              >
            </h5>
          </div>
          <b-table
            class="mt-3"
            striped
            hover
            :items="dataATKTest"
            :fields="fields"
            :busy="tableLoading"
            responsive="sm"
            show-empty
          >
            <template v-slot:table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                Loading...
              </div>
            </template>
            <template v-slot:cell(check_date)="row">{{
              moment(row.item.check_date).format("DD / MM / YYYY")
            }}</template>
          </b-table>
        </b-card>
      </b-col>
      <b-col cols="12" sm="12" md="5" order-md="1">
        <b-alert v-if="dataBlock.length != 0" style="border-radius:5px;" show variant="danger-block" class="text-center">
            <!-- <pre>{{ dataBlock }}</pre> -->
            <b-media>
              <template #aside>
                <i class="fa fa-2x mt-2 text-white fa-exclamation-triangle" aria-hidden="true" />
              </template><p class="mb-0 text-white font-weight-bold">
                You are not allowed to enter the premises during {{ moment(dataBlock[0].start_time).format('LL') }} - {{ moment(dataBlock[0].end_time).format('LL') }} because of COVID-19 Restriction.
              </p>
            </b-media>
        </b-alert>
        <!--  
          <b-card class="mb-2">
            <b-card-text>
              <h5 class="font-weight-bold mt-0 mb-3">
                COVID-19 vaccination status
              </h5>
              <div v-if="dataVac.length != 0">
                <div class="d-flex justify-content-between w-100">
                  <p class="mt-1 mb-1">No. of doses</p>
                  <p class="font-weight-bold mt-1 mb-1">{{ dataVac[0].result_detail === '3 doses received' ? '3 doses received or more than' : dataVac[0].result_detail }}</p>
                </div>
                <div class="d-flex justify-content-between w-100">
                  <p class="mt-1 mb-1">Status</p>
                  <p class="font-weight-bold mt-1 mb-1"><span :class="{ 'text-success' : dataVac[0].status === 'fully','text-danger' : dataVac[0].status === 'not_fully' }" >{{ dataVac[0].status_detail }}</span></p>
                </div>
                <div class="d-flex justify-content-between w-100">
                  <p class="mt-1 mb-1">Update at</p>
                  <p class="font-weight-bold mt-1 mb-1">{{ moment(dataVac[0].created_at).format("DD/MM/YYYY") }}</p>
                </div>
              </div>
              <div class="mt-2 mb-3">
                <b-button
                  @click="modalAddVacine"
                  class="text-capitalize font-weight-bold"
                  size="sm"
                  block
                  variant="info"
                  >Update</b-button
                >
              </div>
            </b-card-text>
          </b-card>
        -->
        <b-card>
          <b-card-text>
            <h5 class="font-weight-bold mt-0 mb-3">
              Submit ATK result (ส่งผลตรวจ ATK)
            </h5>
            <label class="text-dark f-16">Result (ผลตรวจ):</label>
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="negative"
                size="lg"
                ><p class="font-weight-bold mt-1 mb-0 text-success">
                  (-) Negative
                </p></b-form-radio
              >
              <b-form-radio
                class="mt-3"
                v-model="selected"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="positive"
                size="lg"
                ><p class="font-weight-bold mt-1 mb-0 text-danger">
                  (+) Positive
                </p></b-form-radio
              >
            </b-form-group>
            <b-alert class="mt-1 mb-3" style="border-radius:5px;" show variant="warning-form">
              <!-- <pre>{{ dataBlock }}</pre> -->
              <b-media>
                <template #aside>
                  <i class="fa fa-2x mt-2 text-white fa-pencil-square-o" aria-hidden="true" />
                </template>
                <h5 class="mt-0 mb-2 text-white">COVID Support</h5>
                <h6 class="mt-0 mb-2 text-white">If you test positive (ATK of RT-PCR) or at high risk, please take this survey.</h6>
                <h5 class="mt-0 mb-0 text-white">Situation Form : <a rel="noopener noreferrer" class="text-info-s font-weight-bold" target="_blank" href="https://docs.google.com/forms/d/1CDVNUhJC6bsmE1qNhDlJwJyDGMjDaFVzmnkMuTDkd00/viewform?edit_requested=true">Click Here</a></h5>
              </b-media>
          </b-alert>
            <div v-if="selected === 'negative' || selected === ''">
              <b-form-group
                description="Allowed file types are { png | jpg | jpeg }. Max size is 2MB."
              >
                <label class="text-dark f-16"
                  >Upload ATK image (รูปถ่าย ATK):
                  <span class="text-danger">*</span></label
                >
                <b-form-file
                  class="mb-1"
                  v-model="file1"
                  placeholder="Choose a image test..."
                  accept="image/*;capture=camera"
                  :disabled="selected === 'positive'"
                  ref="fileAtk"
                ></b-form-file>
              </b-form-group>
              <label class="text-dark f-16"
                >Test Date (วันที่ตรวจ):
                <span class="text-danger">*</span></label
              >
              <v-date-picker
                v-model="date"
                :min-date="minDay"
                :max-date="new Date()"
                :masks="masks"
                visible
                :disabled="selected === 'positive'"
              />
              <b-alert class="mt-3 mb-2" variant="info-cus" show>
                <p class="text-title-consent mt-3 mb-2 text-justify">
                  This data is being collected to comply with a Nakorn Pathom
                  province policy according to the epidemic security measures
                  that individuals entering the campus need to test ATK
                  negative.
                  ข้อมูลนี้ถูกจัดเก็บตามระเบียบของจังหวัดนครปฐมเพื่อยืนยันว่าบุคคลที่เข้าอาคารทุกคนมีผลตรวจ
                  ATK เป็นลบเท่านั้น
                </p>
                <!-- consent - 1 -->
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="consent"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                  :disabled="selected === 'positive'"
                  class="mt-3 mb-2"
                  size="lg"
                >
                  <p class="text-justify mt-0 mb-0 text-head-consent">
                    {{ text_1 }}
                  </p>
                </b-form-checkbox>
                <!-- consent - 1 -->
                <!-- consent - 2 -->
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="consent_2"
                  name="checkbox-2"
                  value="accepted"
                  unchecked-value="not_accepted"
                  :disabled="selected === 'positive'"
                  class="mt-3 mb-2"
                  size="lg"
                >
                  <p class="text-justify mt-0 mb-0 text-head-consent">
                    {{ text_2 }}
                  </p>
                </b-form-checkbox>
                <!-- consent - 2 -->
              </b-alert>
            </div>
            <div v-else>
              <b-alert show variant="danger-block"
                ><strong class="text-white"
                  >Entry is NOT permitted. Please notify your chief immediately.
                  ไม่อนุญาตให้เข้าพื้นที่
                  กรุณาแจ้งหัวหน้างานให้ทราบโดยด่วน</strong
                ></b-alert
              >
            </div>
            <!-- btn action -->
            <div v-if="selected === 'negative' || selected === ''">
              <b-button
                v-if="!btnLoading"
                variant="success"
                class="mt-3 font-weight-bold text-capitalize f-20"
                block
                :disabled="
                  consent === 'not_accepted' ||
                  consent_2 === 'not_accepted' ||
                  file1.length == 0 ||
                  selected === '' ||
                  date === ''
                "
                @click="submitTestKit"
                >Submit</b-button
              >
              <b-button
                v-else
                variant="info"
                class="mt-3 font-weight-bold"
                size="sm"
                block
                disabled
              >
                <b-spinner class="mr-2" small></b-spinner>Submit
              </b-button>
              <b-alert
                v-if="error"
                class="mt-3 mb-2 text-center"
                show
                variant="danger-cus"
                ><strong>{{ error }}</strong></b-alert
              >
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <!-- modal - submit atk auccess -->
    <b-modal ref="my-modal" hide-footer hide-header-close>
      <template #modal-title>
        <h5 class="mt-0 mb-0 font-weight-bold text-capitalize">
          Submission Successful
        </h5>
      </template>
      <div class="d-block text-center">
        <h4 class="mt-2 mb-2 font-weight-bold text-success">
          <i class="fa fa-check mr-2" aria-hidden="true" />Your results have
          been saved.
        </h4>
        <h5 class="mt-0 mb-2 font-th">(ข้อมูลของท่านถูกบันทึกเรียบร้อย)</h5>
      </div>
      <div class="text-right">
        <b-button
          class="mt-3 text-capitalize"
          variant="danger"
          @click="hideModal"
          >Close</b-button
        >
      </div>
    </b-modal>
    <!-- modal - submit vaccine auccess -->
    <b-modal ref="my-modal-vac" hide-footer hide-header-close>
      <template #modal-title>
        <h6 class="mt-0 mb-0 font-weight-bold text-dark">
          <span class="text-capitalize">Please</span
          ><span class="text-lowercase ml-2"
            >select the response that best represents your COVID-19 vaccination
            status today</span
          >
        </h6>
      </template>
      <div class="d-block">
        <b-form-group
          v-slot="{ ariaDescribedby }"
          v-for="(itemC, index) in choiceVacince"
          :key="'V' + index"
        >
          <b-form-radio
            v-model="selectedVac"
            :options="choiceVacince"
            :aria-describedby="ariaDescribedby"
            name="some-vac"
            :value="itemC.value"
            ><strong>{{ itemC.text }}</strong></b-form-radio
          >
        </b-form-group>
        <b-alert class="mt-3 mb-2" variant="info-cus" show>
          <!-- consent - 1 -->
          <b-form-checkbox
            id="checkbox-11"
            v-model="conVacA"
            name="checkbox-11"
            value="accepted"
            unchecked-value="not_accepted"
            class="mt-3 mb-2"
            size="lg"
          >
            <p class="text-justify mt-0 mb-0 text-head-consent">
              {{ text_1 }}
            </p>
          </b-form-checkbox>
          <!-- consent - 1 -->
          <!-- consent - 2 -->
          <b-form-checkbox
            id="checkbox-22"
            v-model="conVacB"
            name="checkbox-22"
            value="accepted"
            unchecked-value="not_accepted"
            class="mt-3 mb-2"
            size="lg"
          >
            <p class="text-justify mt-0 mb-0 text-head-consent">
              {{ text_2 }}
            </p>
          </b-form-checkbox>
          <!-- consent - 2 -->
        </b-alert>
      </div>
      <div class="text-right">
        <b-button
          variant="success"
          class="mt-3 mr-2 font-weight-bold text-capitalize"
          :disabled="
            selectedVac === '' ||
            conVacA === 'not_accepted' ||
            conVacB === 'not_accepted'
          "
          @click="submitVaccine"
        >
          Submit
        </b-button>
        <b-button
          class="mt-3 text-capitalize"
          variant="danger"
          @click="closemodalAddVacine"
          >Close</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: "",
      file1: null,
      date: new Date(),
      minDay: "",
      consent: "not_accepted",
      consent_2: "not_accepted",
      dataATKTest: [],
      error: "",
      masks: {
        input: "DD/MM/YYYY",
      },
      // table lists
      fields: [
        {
          sortable: true,
          key: "no",
          label: "No",
          class: "text-center",
        },
        {
          key: "result",
          label: "Result",
          sortable: false,
          class: "text-capitalize",
        },
        {
          key: "check_date",
          label: "Test date",
          sortable: false,
        },
        {
          sortable: true,
          key: "exprise",
          label: "Valid until",
        },
      ],
      // loading
      tableLoading: false,
      btnLoading: false,
      // msg consent
      text_1:
        "I consent to MUIC handling my medical information that \
        I have submitted in this form for the purpose described above. \
        The medical information will not be shared outside of MUIC under any circumstances. \
        ข้าพเจ้ารับทราบและอนุญาตให้วิทยาลัยเก็บรักษาข้อมูลนี้เพื่อจุดประสงค์ข้างต้นเท่านั้นและวิทยาลัยจะไม่เปิดเผยข้อมูลให้แก่บุคคลอื่นในทุกกรณี",
      text_2:
        "I certify that the information in this form and any attached files is true and correct. \
        I understand that I must take full responsibility for the consequences of any false \
        information submitted and that MUIC will not be held liable for any false information. \
        ข้าพเจ้ายืนยันว่าข้อมูลนี้เป็นความจริงทุกประการ ถ้าข้าพเจ้าให้ข้อมูลที่เป็นเท็จและทำให้เกิดความเสียหายขึ้น \
        ข้าพเจ้าจะรับผิดชอบความเสียหายเหล่านั้นทั้งหมดเองและทางวิทยาลัยจะไม่รับผิดชอบแต่อย่างใด",
      // vaccine
      msgErrorVac: "",
      dataVac: [],
      selectedVac: "",
      conVacA: "not_accepted",
      conVacB: "not_accepted",
      choiceVacince: [
        { value: "a", text: "A. 1 dose received" },
        { value: "b", text: "B. 2 dose received" },
        { value: "c", text: "C. 3 dose received or more than" },
        {
          value: "d",
          text: "D. No doses, but intending to receive the vaccine as soon as possible",
        },
        {
          value: "e",
          text: "E. No doses, not intending to receive the vaccine at any time",
        },
      ],
      errorVac: "",
      // info block
      dataBlock:[],
    };
  },
  mounted() {
    this.beforeDate();
    this.getBalcklist();
    this.getVaccineLog();
    this.getAtkTest();
  },
  methods: {
    beforeDate() {
      let yesterday = new Date(this.date.getTime());
      this.minDay = new Date(yesterday.setDate(this.date.getDate() - 6));
    },
    diffExpirseDate(testDate) {
      let formatTestDate = this.moment(testDate).format("YYYY-MM-DD");
      let weekLimit = this.moment(formatTestDate)
        .add(7, "days")
        .format("YYYY-MM-DD");
      let todayNow = this.moment().format("YYYY-MM-DD");
      // console.log(weekLimit)
      // console.log(formatTestDate)
      if (this.moment(weekLimit).isBefore(todayNow)) {
        return false;
      } else {
        return true;
      }
    },
    async getBalcklist(){
      this.dataBlock = []
      try {
        const resBlack = await this.$http.get(`/checkcovid19/blacklist/me/`);
        if (resBlack.status === 200) {
          this.dataBlock.push(resBlack.data)
        } else {
          throw { resBlack };
        }
      } catch (error) {
        this.dataBlock = []
      }
    },
    async getVaccineLog() {
      this.msgErrorVac = "";
      this.dataVac = [];
      try {
        const resVac = await this.$http.get(`/checkcovid19/vaccine/me/`);
        if (resVac.status === 200) {
          this.dataVac.push(resVac.data)
        } else {
          throw { resVac };
        }
      } catch (error) {
        this.msgErrorVac = "Problem !!";
        this.dataVac = [];
      }
    },
    async getAtkTest() {
      this.dataATKTest = []
      this.tableLoading = true;
      let arrTemp = []
      try {
        const res = await this.$http.get(`/checkcovid19/atk/me/`);
        if (res.status === 200) {
          let a = 1;
          arrTemp = res.data.map((item) => ({
            no: a++,
            ...item,
            exprise: this.moment(
              this.moment(item.check_date).format("YYYY-MM-DD")
            )
              .add(7, "days")
              .format("DD / MM / YYYY"),
          }));
          arrTemp.sort(function (a, b) {
            var nameA = a.check_date.toUpperCase();
            var nameB = b.check_date.toUpperCase();
            if (nameA > nameB) {
              return -1;
            }
            if (nameA < nameB) {
              return 1;
            }
            return 0;
          });
          // add data
          for (let a = 0; a < arrTemp.length; a++) {
            const listData = arrTemp[a];
            if(a < 5){
              this.dataATKTest.push(listData)
            }
          }
          this.tableLoading = false;
        } else {
          throw { res };
        }
      } catch (error) {
        this.dataATKTest = [];
        this.tableLoading = false;
      }
    },
    getFileExtensionImage(filename) {
      if (filename) {
        return (
          filename.type === "image/jpg" ||
          filename.type === "image/jpeg" ||
          filename.type === ".heic" ||
          filename.type === "image/png"
        );
      }
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    modalAddVacine() {
      this.selectedVac = "";
      this.conVacA = "not_accepted";
      this.conVacB = "not_accepted";
      this.$refs["my-modal-vac"].show();
    },
    closemodalAddVacine() {
      this.$refs["my-modal-vac"].hide();
      this.selectedVac = "";
      this.conVacA = "not_accepted";
      this.conVacB = "not_accepted";
    },
    async submitTestKit() {
      this.error = "";
      this.btnLoading = true;
      if (this.getFileExtensionImage(this.file1)) {
        try {
          const sendData = new FormData();
          sendData.append("file_img", this.file1);
          sendData.append(
            "check_date",
            this.moment(this.date).format("YYYY-MM-DD")
          );
          const response = await this.$http.post(
            "/checkcovid19/atk/add_data/",
            sendData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          if (response.status === 201) {
            this.showModal();
            this.getAtkTest();
            this.selected = "";
            this.date = new Date();
            this.consent = "not_accepted";
            this.consent_2 = "not_accepted";
            this.file1 = null;
            this.btnLoading = false;
          } else {
            throw { response };
          }
        } catch (error) {
          this.error = "Found a problem, please check your results.";
          this.btnLoading = false;
        }
      } else {
        this.error = "Found a problem, please check your results.";
        this.selected = "";
        this.date = new Date();
        this.consent = "not_accepted";
        this.consent_2 = "not_accepted";
        this.file1 = null;
        this.btnLoading = false;
      }
    },
    async submitVaccine() {
      this.errorVac = "";
      try {
        const sendDataVac = new FormData();
        sendDataVac.append("result", this.selectedVac);
        const response = await this.$http.post(
          "/checkcovid19/vaccine/add_data/",
          sendDataVac,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 201) {
          this.closemodalAddVacine();
          this.showModal();
          this.getVaccineLog();
        } else {
          throw { response }
        }
      } catch (error) {
        this.errorVac = "Found a problem, please check your results.";
      }
    },
  },
};
</script>

<style scoped>
.f-14 {
  font-size: 12px;
}
.f-16 {
  font-size: 16px;
}
.f-20 {
  font-size: 20px;
}
.alert-danger-cus {
  background-color: #fc90a6;
  color: #000000;
}
.alert-info-cus {
  background-color: #e5faff;
  color: #000000;
}
.text-title-consent {
  font-size: 14px;
  font-weight: 700;
}
.text-head-consent {
  font-size: 14px;
  font-weight: 700;
  color: #000000;
}
.font-th {
  font-family: "Kanit", sans-serif;
  font-weight: 300;
}
.alert-danger-block {
    background-color: #f72438;
    color: #B33C12;
}
.alert-warning-form {
    background-color: #f88c3f;
    color: #BB992F;
}
.text-info-s {
    color: #03a9f4 !important;
}
</style>